import React, { useEffect, useRef, useState } from 'react';
import './_codemirror.dark.mode.scss';
import './_codemirror.scss';
import CodeMirror from 'codemirror/lib/codemirror'
import 'codemirror/lib/codemirror.css'
import emmet from '@emmetio/codemirror-plugin';

/* JS */
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/hint/javascript-hint'

/* CSS */
import 'codemirror/mode/css/css'
import 'codemirror/addon/hint/css-hint'

/* HTML, TWIG */
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/mode/twig/twig'
import 'codemirror/mode/xml/xml'
import 'codemirror/addon/mode/multiplex'
import 'codemirror/addon/edit/closebrackets'
import 'codemirror/addon/edit/closetag'

/* Коллапсы */
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/xml-fold'
import 'codemirror/addon/fold/markdown-fold'
import 'codemirror/addon/fold/comment-fold'

import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

const CodeMirrorComponent = ({ value, options, onChange }) => {
  const inputRef = useRef(null);
  const editor = useRef(null);
  const [content, setContent] = useState(value)

  useEffect(() => {
    onChange(content);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content])

  const onChangeContent = (editor) => {
    setContent(editor.getValue())
  }

  const codeMirrorInstance = () => {
    setContent(value)
    if (options?.emmet) {
      /* Emmet */
      emmet(CodeMirror);
    }
    editor.current = CodeMirror.fromTextArea(inputRef.current, { ...options });
    editor.current.on('change', onChangeContent);
  }

  useEffect(() => {
    codeMirrorInstance()
    return () => {
      editor.current.toTextArea();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!isEqual(value, content)) {
      editor.current.toTextArea();
      inputRef.current.value = value;
      codeMirrorInstance()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <div className="codemirror-container">
      <textarea ref={inputRef} defaultValue={value} />
    </div>
  )
};

CodeMirrorComponent.defaultProps = {
  options: {},
}

CodeMirrorComponent.propTypes = {
  value: PropTypes.string,
  options: PropTypes.object,
  onChange: PropTypes.func,
};

export default CodeMirrorComponent;
